export const STATION_LOGO = 'https://static.lumi.new/b7/b7dd2ea4e33c8710f321f3de69725267.webp'
export const FALLBACK_HOST = 'https://static.lumi.new/f2/f2a4f4a9ebce224bf4c2d3d2894790e5.png'
export const FALLBACK_CITY = 'https://static.lumi.new/af/af7317e7ee9efb052f38b323473c9508.png'

export function imageSrc(url?: string | null, fallback = STATION_LOGO) {
  const value = (url || '').trim()
  return value || fallback
}
